import { useMemo } from 'react';
import { usePersonalizedContent } from './usePersonalizedContent';
import { useIsPersonalizedContentEnabled } from './usePersonalizedParams';
export const usePersonalizedFeatures = () => {
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    data,
    enabled,
    isParamsLoading,
    isSuccess,
    isError,
    isLoading
  } = usePersonalizedContent();
  const byFamily = useMemo(() => {
    var _data$features;
    const map = new Map();
    const items = data == null || (_data$features = data.features) == null ? void 0 : _data$features.items;
    if (Array.isArray(items)) {
      items.forEach(item => map.set(item.productFamilyId, item.featureRows));
    }
    return map;
  }, [data]);
  return {
    getFeatureRows: productFamilyId => isEnabled && productFamilyId ? byFamily.get(productFamilyId) : undefined,
    isLoading: isParamsLoading || enabled && (!isSuccess && !isError || isLoading),
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedFeatures.js.map